var module = angular.module('octopusApp.accounts');

module.directive('accountSummary', function() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      account: '=',
    },
    templateUrl: 'areas/accounts/views/account_summary.html'
  };
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/accounts/directives/account_summary.js
// module id = 6303264581400896
// module chunks = 1